import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Default matches filter modals; Create Discount Figma uses 22. */
export const CHECKBOX_DEFAULT_SIZE = 16;

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Checkbox {
  @Input() checked = false;
  @Input() label = '';
  /** Box width/height in px (e.g. 16 or 22). */
  @Input() size = CHECKBOX_DEFAULT_SIZE;

  @Output() checkedChange = new EventEmitter<boolean>();

  get boxSize(): number {
    const n = Number(this.size);
    return Number.isFinite(n) && n > 0 ? n : CHECKBOX_DEFAULT_SIZE;
  }

  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}
